export enum EGoalMetric {
  NET_PROFIT = 'NET_PROFIT',
  NET_REVENUE = 'NET_REVENUE',
}
